// The promo codes the landing accepts, with their days of free access. The
// server's list (server/promoCodes.js) decides; this copy exists so the code
// box can answer before login. tests/unit/promoCodes.test.js fails if the two
// ever differ, so add a code in both places.
export const PROMO_CODE_DAYS = Object.freeze({
  APRIL: 30,
  JOLITA: 30,
  TESTUOJAM: 36500,
  DAIVID: 36500,
  DAVID: 36500,
  ELLI: 36500,
  MIKE: 36500,
  LUKAS: 36500,
  MOKOMES: 90,
});

export const VALID_PROMO_CODES = Object.freeze(Object.keys(PROMO_CODE_DAYS));

// Ten years or more reads as "unlimited", not "36500 days".
export const UNLIMITED_DAYS = 3650;

export const normalizePromoCode = (code) =>
  typeof code === 'string' ? code.trim().toUpperCase() : '';

export const promoDays = (code) => {
  const c = normalizePromoCode(code);
  return Object.prototype.hasOwnProperty.call(PROMO_CODE_DAYS, c) ? PROMO_CODE_DAYS[c] : null;
};

export const isUnlimited = (days) => Number.isFinite(days) && days >= UNLIMITED_DAYS;

// Intl wants Norwegian Bokmal as 'nb'; the app calls it 'no'.
const intlLocale = (lang) => (lang === 'no' ? 'nb' : lang || 'en');

// "90 dienų", "1 diena", "2 dienos", "90 days": the plural form comes from
// Intl, the words from translations (promoGrant.day.one|few|many|other).
export const daysPhrase = (days, t, lang) => {
  let cat = 'other';
  try {
    cat = new Intl.PluralRules(intlLocale(lang)).select(days);
  } catch {
    /* unknown locale: other */
  }
  const key = `promoGrant.day.${cat}`;
  const word = t(key);
  return `${days} ${word === key ? t('promoGrant.day.other') : word}`;
};

export const formatPromoDate = (iso, lang) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(intlLocale(lang), { year: 'numeric', month: 'long', day: 'numeric' }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
};

// Put a formatted date into "{date}." without doubling the full stop: the
// Lithuanian date already ends in one ("2027 m. sausio 10 d.").
export const fillDate = (template, date) =>
  date.endsWith('.') ? template.replace('{date}.', date).replace('{date}', date) : template.replace('{date}', date);
